import React from 'react';
import { Grid } from "../../material-ui"; 
import AppConfig from '../../control/config';

export default class TabIndicator extends React.Component {

    render() {
        const { width, height, color, background } = this.props;
        let wid = width ? width : 20;
        let hei = height ? height : 3; 
        let styles = { backgroundColor: color ? color : AppConfig.tabLineColoor, width: wid, height: hei, borderRadius: hei / 2 };
        if (background) {
            styles = { width: wid, height: hei, borderRadius: hei / 2, background: background };
        }
        return (
            <Grid container direction='row' justifyContent='center' style={{ width: '100%', height: hei }}>
                <div style={styles}></div>
            </Grid>
        );
    }
}
